import apiService from "./apiService";
import AppConstants from "../appConstants";

class AuditlogService {
    getAllAuditlogs(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_AUDITLOG, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getAuditlogDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_AUDITLOG}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerAuditlog(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_AUDITLOG, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteAuditlog(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_AUDITLOG}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadFile(AppConstants.URL_AUDITLOG_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
    // =====================================================================
    
}

export default new AuditlogService();
